import type { MarkNotificationAsDelivered200BasicInfoType } from './markNotificationAsDelivered200BasicInfoType';

export type MarkNotificationAsDelivered200BasicInfo = {
  /** @nullable */
  content?: string | null;
  /** @nullable */
  createdAt?: string | null;
  id: number;
  type: MarkNotificationAsDelivered200BasicInfoType;
  /** @nullable */
  updatedAt?: string | null;
  userId: number;
};
